var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "video_1_",
    "data-name": "video (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.999,
    height: 21.999,
    viewBox: "0 0 25.999 21.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "video_1_2",
    "data-name": "video (1)",
    d: "M28.506,7.138a1,1,0,0,0-.993-.012L22,9.3V9.14A4.145,4.145,0,0,0,17.858,5H7.141A4.145,4.145,0,0,0,3,9.141V22.858A4.145,4.145,0,0,0,7.141,27H17.858A4.145,4.145,0,0,0,22,22.858V22.7l5.514,2.175A1,1,0,0,0,29,24V8a1,1,0,0,0-.493-.862ZM20,22.858A2.143,2.143,0,0,1,17.858,25H7.141A2.143,2.143,0,0,1,5,22.858V9.141A2.143,2.143,0,0,1,7.141,7H17.858A2.143,2.143,0,0,1,20,9.141Zm7-.559-5-1.89V11.589L27,9.7Z",
    transform: "translate(-3 -5)",
    fill: "#24abe2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.a348f8687f38fd90378b8c67d9a013be.svg";
export { ForwardRef as ReactComponent };